import React from 'react';
import PropTypes from 'prop-types';
import './StepConnector.less';

// StepConnector is the line that connects one step to the previous step
// The color of the line represents whether the previous step has been completed or not
function StepConnector({status}) {
  if (status === 'disabled') {
    return (
      <div className='StepConnector StepConnector__disabled'/>
    );
  }

  return (
    <div className='StepConnector StepConnector__completed'/>
  );
}

StepConnector.propTypes = {
  status: PropTypes.string.isRequired
};

export default StepConnector;
